import React from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import { Bar, getElementsAtEvent } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  annotationPlugin
);

export const StockGraph = ({ data }) => {
  const ref = React.useRef();
  const onClick = (e) => {
    if (getElementsAtEvent(ref.current!, e).length > 0) {
      console.log(getElementsAtEvent(ref.current!, e));
      let datasetIndex = getElementsAtEvent(ref.current!, e)[0].datasetIndex;
      let dataPoint = getElementsAtEvent(ref.current!, e)[0].index;

      console.log({
        datasetIndex,
        dataPoint,
        data: data[dataPoint],
      });
    }
  };

  // Helper function to calculate median
  const calculateMedian = (arr) => {
    const sorted = [...arr].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 !== 0
      ? sorted[mid]
      : (sorted[mid - 1] + sorted[mid]) / 2;
  };

  if (data) {
    const stockData = data?.map((scan) => scan.quantity);

    return (
      <Bar
        className="cursor-pointer"
        ref={ref}
        onClick={onClick}
        options={{
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              backgroundColor: "rgba(30, 41, 59, 0.95)",
              padding: 12,
              borderColor: "rgba(51, 65, 85, 1)",
              borderWidth: 1,
              titleColor: "#fff",
              bodyColor: "#fff",
              cornerRadius: 8,
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
              ticks: {
                color: "#6B7280",
                font: {
                  size: 11,
                },
              },
            },
            y: {
              type: "linear" as const,
              display: true,
              position: "left" as const,
              border: {
                display: false,
              },
              grid: {
                color: "rgba(0, 0, 0, 0.05)",
                drawTicks: false,
              },
              ticks: {
                color: "#6B7280",
                font: {
                  size: 11,
                },
                padding: 8,
                callback: function (value) {
                  return Number.isInteger(value) ? value + " pcs" : null;
                },
              },
            },
          },
        }}
        data={{
          labels: data?.map((scan) => {
            let date = new Date(scan.createdAt);

            const joursSemaine = [
              "dim",
              "lun",
              "mar",
              "mer",
              "jeu",
              "ven",
              "sam",
            ];

            let jourSemaine = joursSemaine[date.getDay()];
            let jour = date.getDate().toString().padStart(2, "0");
            let mois = (date.getMonth() + 1).toString().padStart(2, "0");

            return `${jourSemaine} ${jour}/${mois}`;
          }),
          datasets: [
            {
              label: "Stocks",
              data: stockData,
              backgroundColor: "rgba(139, 92, 246, 0.65)",
              borderColor: "rgba(139, 92, 246, 1)",
              borderWidth: 0,
              borderRadius: 6,
              hoverBackgroundColor: "rgba(139, 92, 246, 0.8)",
            },
          ],
        }}
      />
    );
  }

  return null;
};
